import { styled } from '@mui/material';
import { TextInputUnstyled } from 'components/Inputs';

export const StyledBoldInput = styled(TextInputUnstyled)(({ theme }) => ({
  '& .MuiInputBase-root ': {
    '& ::placeholder': {
      color: '#757575',
      opacity: 1,
      fontWeight: 500,
      fontSize: 14,
      textTransform: 'uppercase',
    },
  },
}));

export const StyledLightInput = styled(TextInputUnstyled)(({ theme }) => ({
  '& .MuiInputBase-root ': {
    color: '#000',
    fontWeight: 400,
    fontSize: 16,
    textTransform: 'uppercase',
  },
}));
